import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environmentConfig } from '../../environment';
import { Observable, throwError, catchError } from 'rxjs';



export interface TradingPnlDto {
    tradeDate: string;        // comes back as date from API; we’ll display as string
    exchange: string;
    productId: string;
    baseCurrency: string;
    quoteCurrency: string;
    totalBuySize: number;
    totalSellSize: number;
    totalBuyNotional: number;
    totalSellNotional: number;
    totalFees: number;
    netCashFlow: number;
}

export interface WalletBalanceDto {
    BalanceSnapshotId: number;
    Exchange: string;
    Currency: string;
    Balance: number;
    Available: number;
    Hold: number;
    SnapshotTime: string; // datetimeoffset serialized as string
    Source: string;
}


@Injectable({
    providedIn: 'root'
})

export class TradingDataService {
    private apiUrl = environmentConfig.apiBaseUrl;

    constructor(private http: HttpClient) { }

    private fetchAuthenticated(
        url: string,
        method: 'GET' | 'POST' | 'PUT',
        token: string,
        bodyData?: any
    ): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ` + token
        });
        const httpOptions = { headers };
        let httpCall: Observable<any>;

        if (method === 'GET') {
            httpCall = this.http.get(url, httpOptions);
        } else if (method === 'POST') {
            httpCall = this.http.post(url, bodyData, httpOptions);
        } else if (method === 'PUT') {
            httpCall = this.http.put(url, bodyData, httpOptions);
        } else {
            return throwError(() => new Error('Unsupported method'));
        }

        return httpCall.pipe(
            catchError(error => {
                console.error('❌ HTTP Error:', error);
                return throwError(() => error);
            })
        );
    }

    getLatestCryptoPrices(token: string): Promise<any> {
      try {
        return this.fetchAuthenticated(
          `${this.apiUrl}/api/trading/crypto/latest`,
          'GET',
          token
        ).toPromise();
      } catch (error) {
        return Promise.reject(error);
      }
    }

    getWalletBalances(token: string): Promise<WalletBalanceDto[]> {
        const url = `${this.apiUrl}/api/trading/wallet/balances`;

        return this.fetchAuthenticated(
            url,
            'GET',
            token
        ).toPromise() as Promise<WalletBalanceDto[]>;
    }


    getTradingPnlByDate(
        token: string,
        startDate: Date,
        endDate: Date,
        exchange?: string,
        productId?: string
    ): Promise<TradingPnlDto[]> {
        const params = new URLSearchParams();
        params.set('startDate', startDate.toISOString());
        params.set('endDate', endDate.toISOString());

        if (exchange && exchange.trim().length > 0) {
            params.set('exchange', exchange.trim());
        }

        if (productId && productId.trim().length > 0) {
            params.set('productId', productId.trim());
        }

        const url = `${this.apiUrl}/api/trading/pnl/bydate?${params.toString()}`;

        return this.fetchAuthenticated(
            url,
            'GET',
            token
        ).toPromise() as Promise<TradingPnlDto[]>;
    }
}
